module.exports = __webpack_public_path__ + "img/38_6.cde04475.png";